import {PropsWithChildren} from 'react';
import container from './di/Container.ts';

/* Theme */
import {primitives} from "@yosmanyga/web-primitive-ui";
import {buildTheme as buildBaseTheme} from '@yosmanyga/rich-ui';
import {createGlobalStyle} from '@yosmanyga/web-style';
import {ThemeProvider} from '@yosmanyga/theme';
import {AppWrapper as BaseAppWrapper, buildTheme as buildCoreTheme} from '@yosmanyga/fortaleza-core';
import {variables} from './theme/variables';
import {icons} from './theme/icons';
import font from './assets/fonts/Fortaleza.ttf';
import {buildTheme as buildLocalTheme} from './THEME';
import {build as buildGlobalTheme} from './THEME_GLOBAL';

const GlobalCSS = createGlobalStyle(({theme}) => {
    return `
        @font-face {
            font-family: "Fortaleza";
            src: local("Fortaleza"),
            url(${font}) format("truetype");
        }
        html {
            font-family: "Fortaleza";
            margin: ${theme.html.margin};
            height: ${theme.html.height};
        }
        body {
            margin: ${theme.body.margin};
            background: ${theme.body.background};
            // No scroll
            overflow: hidden;
            height: ${theme.body.height};
        }
        #root {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            min-height: ${theme.body.height};
        }
    `;
});

const ThemeWrapper = ({children}: PropsWithChildren) => {
    return <>
        <GlobalCSS
            theme={buildGlobalTheme({
                ...variables,
            })}
        />
        <ThemeProvider
            build={buildBaseTheme}
            variables={variables}
        >
            <ThemeProvider
                build={buildCoreTheme}
                variables={undefined}
            >
                <ThemeProvider
                    build={buildLocalTheme}
                    variables={undefined}
                >
                    <BaseAppWrapper
                        primitives={primitives}
                        icons={icons}
                        container={container}
                    >
                        {children}
                    </BaseAppWrapper>
                </ThemeProvider>
            </ThemeProvider>
        </ThemeProvider>
    </>
};

export {ThemeWrapper};
